import {Component, OnInit, ViewEncapsulation, AfterViewInit, ChangeDetectorRef} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";
import {MalihuScrollbarService} from "ngx-malihu-scrollbar";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";
import {HeaderComponent} from "../header/header.component";

@Component({
    selector: 'app-attractions',
    templateUrl: './attractions.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AttractionsComponent implements OnInit, AfterViewInit {

    public slug;
    attraction = {
        "title": null,
        "slug": null,
        "content": null,
        "address": null,
        "latitude": null,
        "longitude": null,
        "email": null,
        "phone": null,
        "opening_time": null,
        "closing_time": null,
        "fee": null,
        "website": null,
        "thumbnail_image": null,
        "center_distance": null,
        "area_title": null
    };
    facilities = [];

    // google map
    zoom: number = 16;

    lat: number;
    lng: number;

    markers = {
        "experiences": [],
        "properties": []
    };
    map_tab;

    infoWindow = null;

    galleryOptions = [
        {
            width: '800px',
            height: '750px',
            thumbnailsColumns: 4,
            imagePercent: 80,
            thumbnailsPercent: 17,
            thumbnailsMargin: 5,
            thumbnailMargin: 5
        },

    ];
    galleryImages = [];

    nearby = {
        'attractions': [],
        'shopping': [],
        'art-entertainment': [],
        'eat-drink': [],
        'hotels': []
    };

    nearby_tab;
    navleft = '<i class="icon-angle-left"></i>';
    navright = '<i class="icon-angle-right"></i>';

    rating_order = {};
    reviews_avg = {};
    reviews = [];
    next = null;

    auth_user = new User();
    headersHeight: number;

    constructor(public header: HeaderComponent,
                private router: Router,
                public share: ShareButtons,
                private route: ActivatedRoute,
                private http: HttpClient,
                public _auth: AuthService,
                private authService: AuthServices,
                private ref: ChangeDetectorRef) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];

            this.facilities = [];
            this.markers = {
                "experiences": [],
                "properties": []
            };

            this.map_tab = 'experiences';
            this.nearby_tab = 'attractions';

            this.galleryImages = [];

            this.reviews_avg = {}
            this.reviews = [];
            this.next = null;

            this.getAttraction();

            this.authService.currentUser.subscribe((user: User) => {
                this.auth_user = user;
            });
        });
    }

    ngAfterViewInit() {
        this.headersHeight = $(window).width() > 991 ? $('#header').height() + $('div.fixed-nav').height() : $('.nav-parent').height();
        this.ref.detectChanges();
    }

    getAttraction() {
        this.http.get(Conf.API_URL + '/things-to-do/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.attraction = data['results'][0];
                    this.lat = this.attraction.latitude = parseFloat(this.attraction.latitude);
                    this.lng = this.attraction.longitude = parseFloat(this.attraction.longitude);
                    this.infoWindow = 'current';

                    this.getAttractionImages();
                    this.getNearby();
                    this.getAttractionFacilities();
                    this.getReviews();
                } else {
                    this.router.navigate(['/404']);
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAttractionImages() {
        this.http.get(Conf.API_URL + '/things-to-do-images/?show_all&things_to_do__slug=' + this.slug).subscribe(
            data => {
                let self = this;

                $.each(data['results'], function (index, value) {
                    self.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getReviews(type = 'All') {
        var url = Conf.API_URL + '/things-to-do-reviews/?things_to_do__slug=' + this.slug;
        var url_avg = Conf.API_URL + '/things_to_do-reviews-avg/?things_to_do=' + this.slug;
        if (type != 'All') {
            url += '&sort=' + type;
            url_avg += '&sort=' + type;
        }

        this.http.get(url_avg).subscribe(
            data => {
                this.reviews_avg = data['results'];
                this.rating_order = data['rating_order'];
            },
            error => {
                console.log(error.error)
            }
        );

        this.http.get(url).subscribe(
            data => {
                this.reviews = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                this.reviews = this.reviews.concat(data['results']);
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getNearby() {
        const url = Conf.API_URL + '/things_to_do-nearby-properties/?category=all&slug=' + this.slug;

        this.http.get(url).subscribe(
            data => {
                this.nearby = data['results'];
                let self = this;

                $.each(data['results'], function (category, things) {
                    $.each(things, function (index, value) {
                        if (category == 'hotels') {
                            self.markers['properties'].push({
                                index: index,
                                lat: parseFloat(value.latitude),
                                lng: parseFloat(value.longitude),
                                area: value.area,
                                id: category + value.id,
                                category: category,
                                distance: value.distance,
                                title: value.title,
                                image: value.thumbnail_image,
                            });
                        } else {
                            self.markers['experiences'].push({
                                index: index,
                                lat: parseFloat(value.latitude),
                                lng: parseFloat(value.longitude),
                                area: value.area,
                                id: category + value.id,
                                category: category,
                                title: value.title,
                                image: value.thumbnail_image,
                                distance: value.distance
                            });
                        }
                    });
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAttractionFacilities() {
        this.http.get(Conf.API_URL + '/things-to-do-facility/?things_to_do__slug=' + this.slug).subscribe(
            data => {
                this.facilities = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    selectMapTab(tab) {
        this.map_tab = tab;
        this.lat = this.attraction.latitude;
        this.lng = this.attraction.longitude;
        this.infoWindow = 'current'
    }

    openLogin() {
        this.header.openLogin()
    }

    clickedMarker(category: string, item: any) {
        this.lat = parseFloat(item.latitude);
        this.lng = parseFloat(item.longitude);
        this.infoWindow = category + item.id;
    }

    setTabActive($event): void {
        $('li.tab-link a').removeClass('active');
        $event.target.classList.add('active');
        if ($(window).width() < 991) {
            $('ul.toggle-content').slideToggle();
        }
    }

    getNearbyLinks(tab: string, item: any): string {
        switch (tab) {
            case 'attractions': return `/attractions/${item.slug}`;
            case 'eat-drink': return `/eat-and-drink/${item.categories.category_slug}/${item.slug}`;
            case 'shopping': return `/shopping/${item.slug}`;
            case 'hotels': return `/accommodations/${item.categories.category_slug}/${item.slug}`;
            default: return '/404';
        }
    }
}


// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/attractions/attractions.component.ts